if (!customElements.get('reveal-content')) {
  customElements.define(
    'reveal-content',
    class RevealContent extends HTMLElement {
      constructor() {
        super();

        this.CLASSES = {
          isFixed: 'reveal-content--is-fixed',
        };

        window.addEventListener('scroll', this.handleScroll.bind(this));
      }

      handleScroll() {
        if (!this.getBoundingClientRect()) return;

        this.getBoundingClientRect().top <= 0
          ? this.classList.remove(this.CLASSES.isFixed)
          : this.classList.add(this.CLASSES.isFixed);
      }
    },
  );
}
